<template>
	<v-container v-if="load.status != 'deleted'" >
		<div class="load">

			<load-head
					:id="load.load_id"
					:isLoadLength="isLoadLength"
					@updateRemoveLoad="onRemoveLoad"
			></load-head>

			<general-items
					:load="load"
					:brokers="brokers"
					:errors="errorsGeneral"
					@updateAutocomplete="onAutocomplete"
					@updateInput="onInput"
					@updateSearchText="onSearchText"
			></general-items>

			<dimensions
					:load="load"
					@updateInput="onInput"
					@updateSwitch="onSwitch"
			></dimensions>

			<pickup-delivery
					v-if="defaultLocation"
					load-title="Pickup information"
					load-add-new="Add pickup"
					load-key="pickup"
					:load="load"
					:default-location="defaultLocation"
					:errors="errorsPickup"
					@updateAddItem="onAddItemPickup"
					@updateDeleteItem="onDeleteItemPickup"
					@updateInput="onInputPickup"
					@updateTime="onTimePickup"
					@updateAutocomplete="onAutocompletePickup"
					@updateSearchText="onSearchTextPickup"
			></pickup-delivery>

			<pickup-delivery
					v-if="defaultLocation"
					load-title="Delivery information"
					load-add-new="Add delivery"
					load-key="delivery"
					:load="load"
					:default-location="defaultLocation"
					:errors="errorsDelivery"
					@updateAddItem="onAddItemPickup"
					@updateDeleteItem="onDeleteItemPickup"
					@updateInput="onInputPickup"
					@updateTime="onTimePickup"
					@updateAutocomplete="onAutocompletePickup"
					@updateSearchText="onSearchTextPickup"
			></pickup-delivery>

			<mileage
					:load="load"
					:old-route="oldRoute"
					:invalidPickup="invalidPickup"
					:invalidDelivery="invalidDelivery"
					:errors="errorsMileage"
					@updateInput="onInput"
					@updateCustomIconButton="onCustomIconButton"
					@updateOpenOldTrip="onOpenOldTrip"
			></mileage>

			<payments
					:load="load"
					@updateAddItem="onAddItem"
					@updateEditItem="onEditItem"
			></payments>

			<notes
					:load="load"
					@updateAddItem="onAddItem"
					@updateEditItem="onEditItem"
			></notes>

			<files
					:load="load"
					:typeBilling="load.billing.type"
					@updateGuide="onGuide"
					@updateEditItem="onEditItem"
					@updateNewItem="setNewItem"
			></files>

			<billing
					v-if="this.load.billing_switch && this.load.customer_billing"
					:load="load"
					:typeBilling="load.billing.type"
					:ppw="load.ppw_date"
					@updateGuide="onGuide"
					@updateCreateInvoice="onCreateInvoice"
					@updateCustomIconButton="onCustomIconButton"
			></billing>

			<paper-work
					v-if="this.load.billing.type"
					:load="load"
					@updateGuide="onGuide"
					@updateAddItem="onGenerateFilePPW"
					@updateCustomIconButton="onCustomIconButton"
			></paper-work>

		</div>
	</v-container>
</template>

<script>
// Components
import LoadHead from "@/components/Dispatch/Trips/DialogTrip/Load/LoadHead/LoadHead";
import GeneralItems from "@/components/Dispatch/Trips/DialogTrip/Load/GeneralItems/GeneralItems";
import Dimensions from "@/components/Dispatch/Trips/DialogTrip/Load/Dimensions/Dimensions";
import PickupDelivery from "@/components/Dispatch/Trips/DialogTrip/Load/PickupDelivery/PickupDelivery.vue";
import Payments from "@/components/Dispatch/Trips/DialogTrip/Load/Payments/Payments";
import Notes from "@/components/Dispatch/Trips/DialogTrip/Load/Notes/Notes";
import Files from "@/components/Dispatch/Trips/DialogTrip/Load/Files/Files";
import Mileage from "@/components/Dispatch/Trips/DialogTrip/Load/Mileage/Mileage";
import Billing from "@/components/Dispatch/Trips/DialogTrip/Load/Billing/Billing";
import PaperWork from "@/components/Dispatch/Trips/DialogTrip/Load/PaperWork/PaperWork";
// Helpers
import { loadType } from "@/components/Dispatch/Trips/DialogTrip/constants";

export default {
	name: "Load",
	components: {
		LoadHead,
		GeneralItems,
		Dimensions,
		PickupDelivery,
		Payments,
		Notes,
		Files,
		Mileage,
		Billing,
		PaperWork,
	},
	props: {
		load: Object,
		brokers: Array,
		defaultLocation: Array,
		oldRoute: Object,
		isLoadLength: Boolean,
		invalidPickup: Boolean,
		invalidDelivery: Boolean,
		flag: [ String, Number ],
		errorsPickup: Object,
		errorsDelivery: Object,
		errorsGeneral: Object,
		errorsMileage: Object,
	},
	computed: {
		loadTypeList() {
			return loadType;
		},
		getBillingService() {
			return this.load.customer_billing ? 'Active' : 'Not active';
		},
	},
	data() {
		return {
			// loadType: null,
		};
	},
	methods: {
		onGenerateFilePPW() {
			this.$emit('updateGenerateFilePPW', { load: this.load });
		},
		onOpenOldTrip(id) {
			this.$emit('updateOpenOldTrip', id);
		},
		onCustomIconButton(args) {
			this.$emit('updateCustomIconButton', { load: this.load, args });
		},
		onDeleteItemPickup({ index, flag }) {
			this.$emit('updateDeleteItemPickup', { index, flag });
		},
		onCreateInvoice() {
			this.$emit('updateCreateInvoice', { load: this.load });
		},
		onAddItemPickup(flag) {
			this.$emit('updateAddItemPickup', { flag, load: this.load });
		},
		onGuide(nameComponent) {
			this.$emit('updateLoadGuide', { nameComponent, load: this.load });
		},
		onAddItem(nameComponent) {
			this.$emit('updateAddItem', { nameComponent, load: this.load });
		},
		onEditItem({ key, item, nameComponent, itemIndex }) {
			this.$emit('updateEditItem', { key, item, nameComponent, itemIndex, load: this.load });
		},
		onRemoveLoad() {
			this.$emit('updateRemoveLoad', this.load);
		},
		onAutocomplete({ value, key, id }) {
			this.$emit('updateLoadAutocomplete', { value, key, id });
		},

		onAutocompletePickup({ args, index, flag }) {
			this.$emit('updateLoadAutocompletePickup', { args, index, flag });
		},
		onInputPickup({ args, index, flag }) {
			this.$emit('updateLoadPickupInput', { args, index, flag });
		},

		onInput({ value, key, parent }) {
			this.$emit('updateLoadInput', { value, key, parent });
		},
		onTimePickup({ args, index, flag }) {
			this.$emit('updateLoadPickupTime', { args, index, flag });
		},
		onSearchText(args) {
			this.$emit('updateSearchText', args);
		},
		onSearchTextPickup(args) {
			this.$emit('updateSearchTextPickup', args);
		},
		onSwitch({ value, key }) {
			this.$emit('updateLoadSwitch', { value, key });
		},
		setNewItem(args) {
			this.$emit('updateNewItem', args);
		},
	}
};
</script>

<style scoped lang="scss">
@import "load";
.load {
	background: var(--card-bg-opacity);
}
</style>
